module.exports = __webpack_public_path__ + "img/P150T_weapon_38.a70aed41.png";